import { Fab, Zoom } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import { Container } from "./styles";

type Props = {
  onCancel: () => void;
  onSave: () => void;
  canSave: boolean;
};

export default function EditPageSpeedDial({ onCancel, onSave, canSave }: Props) {
  return (
    <Container
      sx={{
        margin: 0,
        top: "auto",
        right: 20,
        bottom: 20,
        left: "auto",
        position: "fixed",
      }}
    >
      <Zoom
        key="cancel"
        in
        timeout={400}
        style={{
          transitionDelay: "100ms",
        }}
        unmountOnExit
      >
        <Fab
          onClick={onCancel}
          color="secondary"
          size="medium"
          aria-label="cancel"
          sx={{ mb: 1.5 }}
        >
          <CloseIcon />
        </Fab>
      </Zoom>

      <Zoom key="accept" in timeout={200} unmountOnExit>
        <Fab onClick={onSave} color="success" aria-label="save" disabled={!canSave}>
          <CheckIcon />
        </Fab>
      </Zoom>
    </Container>
  );
}
